var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderPurchase',{attrs:{"header":"ยืนยันการสร้างรายการใบสั่งซื้อ","img_header":_vm.header_image,"link_back":"addpurchase"}}),_c('ConfirmAdd_Purchase')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }